exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.keywordbox[data-v-c71ff98a] {\r\n  background-color: white;\r\n  font-size: 12px;\r\n  border: 1px solid #dcdee2;\r\n  border-radius: 6px;\r\n  margin-bottom: 0px;\r\n  padding: 0 5px;\r\n  text-align: left;\r\n  box-sizing: border-box;\n}\r\n", ""]);

// exports
